import { render, staticRenderFns } from "./InformeAuditoriaFieldArbitro.vue?vue&type=template&id=21fb3f7b&"
import script from "./InformeAuditoriaFieldArbitro.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaFieldArbitro.vue?vue&type=script&lang=js&"
import style0 from "./InformeAuditoriaFieldArbitro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCardText,
  VCardTitle,
  VChip,
  VDataTable,
  VFlex,
  VIcon,
  VImg,
  VSelect,
  VTextarea,
  VTooltip,
})
